import { useCms } from '@/use/use-cms'
import { getRandomElement } from '../../utils/helpers'

export const state = {
  all: undefined,
  current: undefined,
}

export const getters = {
  all(state) {
    return state.all
  },
  current(state) {
    return state.current
  },
  randCurrent(state) {
    return getRandomElement(state.current)
  },
  randAll(state) {
    return getRandomElement(state.all)
  },
}

export const mutations = {
  SET_ALL_NEIGHBORHOODS(state, neighborhoodsList) {
    state.all = neighborhoodsList
  },
  SET_CURRENT_NEIGHBORHOODS(state, currentNeighborhoods) {
    state.current = currentNeighborhoods
  },
}

export const actions = {
  async fetchAndSetNeighborhoods({ commit, dispatch, rootGetters }) {
    const { fetchNeighborhoods } = useCms()
    const neighborhoodsList = await fetchNeighborhoods()

    commit('SET_ALL_NEIGHBORHOODS', neighborhoodsList)

    const acronym = rootGetters['auth/currentProfile'].property?.acronym
    let currentNeighborhoods
    if (acronym) {
      currentNeighborhoods = neighborhoodsList.filter(neighborhood =>
        neighborhood.properties.find(property => property.acronym === acronym)
      )
      commit('SET_CURRENT_NEIGHBORHOODS', currentNeighborhoods)
    }
  },
}
